const type = 'SET_CUSTOMER_LATEST_TRANSACTIONS_LOADING';

const setCustomerLatestAuthorizationsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerLatestAuthorizationsLoading;
